import { createContext } from 'react';
import { createNamespace } from '../utils';
import { zhCN as locale } from '../locale';
export const defaultPrefixCls = 'rv';
export const defaultIconPrefixCls = 'van-icon';
export const INITIAL_STATE = {
  prefixCls: defaultPrefixCls,
  locale,
  createNamespace: (name, prefix) => {
    return createNamespace(name, prefix);
  }
};
const ConfigProvider = createContext(INITIAL_STATE);
export default ConfigProvider;